// extracted by mini-css-extract-plugin
module.exports = {"anchor-text":"AnchorTextCustom_anchor-text__3bOMB","back-anchor":"AnchorTextCustom_back-anchor__1Y_XM"};